import React, { useState, Fragment } from "react";
import SignaturePad from "../../components/widgets/signaturePad";
import { Row, Col, Container, Form, Alert } from "@themesberg/react-bootstrap";
import LOGO from '../../assets/img/logo.jpg';
import { post } from "../../services/back.service";

export default function ProtectionLaw() {
  const [isAccepted, setIsAccepted] = useState(false);
  const [inprocess, setInProcess] = useState(false);
  const [formData, setFormData] = useState({
    id_client: '',
    name_client: '',
    plate: '',
  });
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const clearForm = () => {
    setFormData({
      id_client: '',
      name_client: '',
      plate: '',
    });
    setIsAccepted(false);
  };

  const sendSignature = async (signature) => {
    if (!formData.id_client || !formData.name_client || !formData.plate) {
      setAlert({
        show: true,
        message: 'Por favor complete todos los campos requeridos',
        type: 'danger'
      });
      return;
    }

    setInProcess(true);
    const url = `/client/protection_data_law`;
    const response = await post(url, {
      id_client: formData.id_client,
      name_client: formData.name_client,
      plate: formData.plate,
      signature: signature
    }, {});
    if (response.success) {
      setAlert({
        show: true,
        message: 'Firma registrada exitosamente',
        type: 'success'
      });
      clearForm();
    } else {
      setAlert({
        show: true,
        message: 'Error al registrar la firma',
        type: 'danger'
      });
    }
    setInProcess(false);
  }

  return (
    <Fragment>
      <Container>
        {alert.show && (
          <Alert
            variant={alert.type}
            onClose={() => setAlert({ show: false })}
            dismissible
          >
            {alert.message}
          </Alert>
        )}
        <Row className="justify-content-start form-bg-image">
          <Col xs={12} md={4}>
            <div className="text-center text-md-start mb-4 mt-md-0">
              <img src={LOGO} width={250} alt="IntegraMotor - Centro integral automotor" />
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs={12} md={6}>
            <Form className="mb-4">
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Identificación del Cliente</Form.Label>
                    <Form.Control
                      type="text"
                      name="id_client"
                      value={formData.id_client}
                      onChange={handleInputChange}
                      placeholder="Ingrese su identificación"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nombre del Cliente</Form.Label>
                    <Form.Control
                      type="text"
                      name="name_client"
                      value={formData.name_client}
                      onChange={handleInputChange}
                      placeholder="Ingrese su nombre completo"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Placa</Form.Label>
                    <Form.Control
                      type="text"
                      name="plate"
                      value={formData.plate}
                      onChange={handleInputChange}
                      placeholder="AAA123"
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col xs={12} className="text-center">
            <div className="text-center mb-4">
              <img src="/protection_law.jpg" alt="Ley de Protección de Datos" className="img-fluid" style={{ maxWidth: '100%', height: 'auto' }} />
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs={12} className="text-center">
            <div className="mb-4">
              <div className="flex items-center justify-content-center mb-2">
                <input
                  type="checkbox"
                  id="acceptTerms"
                  checked={isAccepted}
                  onChange={(e) => setIsAccepted(e.target.checked)}
                  className="mr-2"
                />
                <label htmlFor="acceptTerms" className="m-2 text-sm">
                  Acepto los términos y condiciones de la Ley de Protección de Datos
                </label>
              </div>
              {/* <p className="text-sm text-gray-600 italic">
                Nota: Una copia del documento será enviada a su correo electrónico para su registro.
              </p> */}
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            {isAccepted && formData.id_client && formData.name_client && (
              <>
                <SignaturePad sendSignature={sendSignature} loading={inprocess} clearSignature={clearForm} />
              </>
            )}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}
